import React from 'react'
import PropTypes from 'prop-types'

import Dialog from 'material-ui/Dialog'
import FlatButton from 'material-ui/FlatButton'

export const MultiTasks = '0'
export const SingleTask = '1'

export default class MultiTasksConfirmationDialog extends React.Component {

  static propTypes = {
    open: PropTypes.bool,
    onDialogResult: PropTypes.func.isRequired,
    onRequestClose: PropTypes.func.isRequired
  }

  handleDialogResult = (event, result) => {
    event.preventDefault()
    this.props.onDialogResult(result)
  }

  render() {
    return (
      <Dialog
        actions={[
          <FlatButton
            key='no'
            label="No"
            primary={true}
            onTouchTap={event => this.handleDialogResult(event, SingleTask)} />,
          <FlatButton
            key='yes'
            label="Yes"
            primary={true}
            onTouchTap={event => this.handleDialogResult(event, MultiTasks)} />
        ]}
        modal={false}
        open={this.props.open}
        contentStyle={{ maxWidth: 400 }}
        title={'Multiple tasks input'}
        onRequestClose={() => this.props.onRequestClose()}>
        { 'Looks like you entered multiple items. Would you like to convert them to separate individual tasks?' }
      </Dialog>
    )
  }

}



// WEBPACK FOOTER //
// ./src/schedule/common/modules/tasks/MultiTasksConfirmationDialog.js